<app-loader></app-loader>
<router-outlet></router-outlet>

<p-dialog
  [header]="'common.dialog.title.warning' | translate"
  [(visible)]="isShowTimeoutDialog"
  [modal]="true"
  [closable]="false"
  (onHide)="onTimeoutDialogHide()"
  class="dialog-timeout"
>
  <div>{{ idleState }}</div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary" (click)="extendTimeout()">{{ 'button.label.extend' | translate }}</button>
  </ng-template>
</p-dialog>

<p-toast key="toast"></p-toast>

<p-confirmDialog key="global"></p-confirmDialog>
<p-confirmDialog key="global-error" [styleClass]="'confirm-dialog-error'"></p-confirmDialog>
<p-confirmDialog key="global-success" [styleClass]="'confirm-dialog-success'"></p-confirmDialog>